<div
  fxLayout="row"
  fxLayoutAlign="start center">
  <div
    class="avatar"
    fxLayout="row"
    fxLayoutAlign="center center"
    [style.backgroundColor]="backgroundColor"
    [style.height]="size + 'px'"
    [style.width]="size + 'px'"
    [style.background-image]="backgroundImageUrl">
    @if (!imageLoaded) {
      <span
        class="initials"
        [style.font-size.px]="fontSize">
        {{ textValue }}
      </span>
    }
  </div>
  <img
    #img
    [hidden]="true"
    [src]="imageUrl"
    (load)="onImageLoaded(true)"
    (error)="onImageLoaded(false)" />
  @if (showName) {
    <div
      class="ml-2">
      {{ name }}
    </div>
  }
</div>
